{
  "toast": {
    "crossDockStaged": "Cross-dock staged",
    "crossDockCompleted": "Cross-dock terminé",
    "cycleCountCreated": "Cycle count créé",
    "countRecorded": "Count enregistré",
    "cycleCountCompleted": "Cycle count terminé",
    "dockAppointmentScheduled": "Dock appointment scheduled",
    "checkedIn": "Checked in",
    "scanRecorded": "Scan enregistré",
    "putawayConfirmed": "Putaway confirmed",
    "pickConfirmed": "Pick confirmed",
    "pickListCreated": "Pick list créé",
    "packAndDispatchCompleted": "Pack and dispatch terminé",
    "warehouseCreated": "Warehouse créé",
    "zoneCreated": "Zone créé",
    "binCreated": "Bin créé",
    "transferCreated": "Transfer créé",
    "transferSubmittedForApproval": "Transfer soumis pour approbation",
    "transferCancelled": "Transfer annulé",
    "waveCreated": "Wave créé",
    "waveReleased": "Wave released",
    "transferAction": "Transfert {{action}}"
  },
  "errors": {
    "failedToLoadCrossDock": "Échec du chargement de cross-dock",
    "stageCrossDockFailed": "Échec de stage cross-dock",
    "completeCrossDockFailed": "Échec de complete cross-dock",
    "failedToLoadCounts": "Échec du chargement de counts",
    "failedToLoadCountLines": "Échec du chargement de count lines",
    "createCycleCountFailed": "Échec de create cycle count",
    "recordCountFailed": "Échec de record count",
    "failedToLoadDockAppointments": "Échec du chargement de dock appointments",
    "scheduleFailed": "Échec de schedule",
    "checkInFailed": "Échec de check-in",
    "failedToLoadLaborMetrics": "Échec du chargement de labor metrics",
    "failedToLoadTasks": "Échec du chargement de tasks",
    "scanFailed": "Échec de scan",
    "putawayFailed": "Échec de putaway",
    "pickFailed": "Échec de pick",
    "failedToLoadPutawayTasks": "Échec du chargement de putaway tasks",
    "failedToLoadPickLists": "Échec du chargement de pick lists",
    "failedToLoadTransfers": "Échec du chargement de transfers",
    "failedToLoadPicks": "Échec du chargement de picks",
    "createPickFailed": "Échec de create pick",
    "confirmPickFailed": "Échec de confirm pick",
    "packDispatchFailed": "Échec de pack/dispatch",
    "failedToLoadWarehouses": "Échec du chargement de warehouses",
    "failedToLoadZonesBins": "Échec du chargement de zones/bins",
    "createWarehouseFailed": "Échec de create warehouse",
    "createZoneFailed": "Échec de create zone",
    "createBinFailed": "Échec de create bin",
    "createTransferFailed": "Échec de create transfer",
    "submitFailed": "Échec de la soumission",
    "cancelFailed": "Échec de l'annulation",
    "failedToLoadWaves": "Échec du chargement de waves",
    "createWaveFailed": "Échec de create wave",
    "releaseWaveFailed": "Échec de release wave",
    "transferActionFailed": "Échec du transfert {{action}}"
  },
  "pages": {
    "crossDockStaging": "Cross-dock staging",
    "cycleCounts": "Cycle counts",
    "warehouseWms": "Entrepôt (WMS)",
    "warehouseDetails": "Entrepôt details",
    "warehouses": "Entrepôts",
    "openPutaway": "Open putaway",
    "floorOperationsPicksTransfersAndMovement": "Floor operations, picks, transfers, et movement activity pour votre entrepôts",
    "dockScheduling": "Dock scheduling",
    "laborMetrics": "Labor metrics",
    "wmsMobile": "WMS Mobile",
    "floorTasksForPutawayAndPicking": "Floor tasks pour putaway et picking",
    "floorOperations": "Floor operations",
    "pickPackDispatch": "Pick / pack / dispatch",
    "warehouseSetup": "Entrepôt setup",
    "warehouseTransfers": "Entrepôt transfers",
    "wavePicking": "Wave picking"
  },
  "labels": {
    "warehouse": "Entrepôt",
    "product": "Produit *",
    "quantity": "Quantity",
    "productOptionalLine": "Produit (optional line)",
    "physicalQuantity": "Physical quantity",
    "dockId": "Dock ID",
    "carrier": "Carrier",
    "startLocal": "Start (local)",
    "endLocal": "End (local)",
    "day": "Day",
    "barcode": "Barcode",
    "targetBinIdPutaway": "Target bin ID (putaway)",
    "targetBinIdOptional": "Target bin ID (optional)",
    "scanBarcode": "Scan barcode",
    "pickedQtyConfirm": "Picked qty (confirm)",
    "carrierRefDispatch": "Carrier ref (dispatch)",
    "code": "Code",
    "name": "Nom",
    "type": "Type",
    "zoneCode": "Zone code",
    "zoneName": "Zone name",
    "binCode": "Bin code",
    "fromWarehouse": "From entrepôt",
    "toWarehouse": "To entrepôt"
  },
  "formActions": {
    "addZone": "Ajouter une zone",
    "addBin": "Ajouter un emplacement"
  },
  "listActions": {
    "recordScan": "Enregistrer le scan"
  }
}
